import { CustomerAddressType } from "../Account/Address";

export class CustomerShippingInfo {
    DeliveryAddress: CustomerAddressType;
    InvoiceAddress: CustomerAddressType;
    Status: ShippingStatus;
}

export enum ShippingStatus {
    PickUp = 0,
    Delivery = 1,
    InProgress = 2,
    Shipped = 3,
    Done = 4
}